// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__B8RAr"};